import dayjs from 'dayjs';

export const calculatePeriodicalDeliveryDate = ({ issueDate, dueDate, deliveryPeriodEnd }) => {
  const issued = dayjs(issueDate);
  const due = dayjs(dueDate);
  const periodEnd = dayjs(deliveryPeriodEnd);

  if (!issued.isValid() || !due.isValid() || !periodEnd.isValid()) return null;

  if (issued.isBefore(periodEnd, 'day') && due.isBefore(periodEnd, 'day')) return issued;
  if (due.isAfter(periodEnd, 'day')) {
    const latestDeliveryDate = periodEnd.add(60, 'day');
    return due.isAfter(latestDeliveryDate, 'day') ? latestDeliveryDate : due;
  }

  return periodEnd;
};
